const documentationNavConf = {
	navItems: [
		{ text: 'Data Download', headingId: 'data-download-h2-data-download', children: [
			{ text: 'Overview Of Data Download Page', headingId: 'data-download-h3-overview-of-data-download-page', children: [
				{ text: 'Preset', headingId: 'data-download-h4-preset' },
				{ text: 'Site Selection', headingId: 'data-download-h4-site-selection' },
				{ text: 'Data Type Selection', headingId: 'data-download-h4-data-type-selection' },
				{ text: 'Show And Download Table', headingId: 'data-download-h4-show-and-download-table' },
			] },
			{ text: 'Preset', headingId: 'data-download-h3-preset', children: [
				{ text: 'Using Preset', headingId: 'data-download-h4-using-preset' },
				{ text: 'Default Preset', headingId: 'data-download-h4-default-presets' },
				{ text: 'Creat Your Custom Preset', headingId: 'data-download-h4-create-your-custom-presets' },
				{ text: 'Edit / Rename preset', headingId: 'data-download-h4-edit-rename-preset' },
			]},
			{ text: 'For GY Users', visibleRoles: ['_GY:Base'], headingId: 'data-download-gy-h3-for-gy-users', children: [
				{ text: 'Select sites by clicking on client name', headingId: 'data-download-gy-h4-select-sites-by-clicking-on-client-name' },
				{ text: 'Data displayed in summary view', headingId: 'data-download-gy-h4-data-displayed-in-summary-view' },
			] },
			{ text: 'For IT Staff Only', visibleRoles: ['_GY:IT'], headingId: 'data-download-it-h3-for-it-staff-only', children: [
				{ text: 'More options while creating or editing preset', headingId: 'data-download-it-h4-more-options-while-creating-or-editing-preset' },
			] },
		] },
	]
};

export default documentationNavConf;